import styled from 'styled-components';
import {GameTitleDefaultBox} from './game-title.default.box';

export const GameTitleSIBox = styled(GameTitleDefaultBox)`
  font-weight: bold;
`
